
import React, { FC, JSX } from "react";
import UserManagementTable from "../../components/user/UserManagementTable";

const AdminAllUsers: FC = (): JSX.Element => {
  return (
    <UserManagementTable
      isAdminView={true}
      pageTitle="All Users"
      pageDescription="View and manage all registered users on the platform"
      showFilters={{
        role: true,
        isMobileVerified: true,
        paymentStatus: true,
        status: true,
      }}
      columns={["Profile", "Name", "Email", "Mobile", "Role", "Status", "Attachments"]}
    />
  );
};

export default AdminAllUsers;
